/*
 * Actions describe changes of state in your application
 */

// We import constants to name our actions' type
import {
  CHANGE_FORM,
  SET_AUTH,
  SENDING_REQUEST,
  LOGIN_REQUEST,
  CHANGE_FORM_REGISTER,
  LOGOUT,
  REQUEST_ERROR,
  CLEAR_ERROR,
  CHANGE_FORM_BUSINESS,
  BUSINESS_TYPES_REQUEST,
  SHOW_PROGRESS_BAR,
  HIDE_PROGRESS_BAR,
  SET_AUTH_FROM_LOCAL,
  SET_AUTH_FROM_API,
  RESEND_VERIFICATION_EMAIL,
  GET_FILTERED_DATE,
  CHANGE_BUSINESS_TYPES_DATA,
  BUSINESS_CATEGORIES_REQUEST,
  BUSINESS_CATEGORIES_ALL_REQUEST,
  BUSINESS_STARTS_REQUEST,
  BUSINESS_LOCATIONS_REQUEST,
  BUSINESS_PROVINCE_REQUEST,
  BUSINESS_ZIPCODE_REQUEST,
  GET_DROPDOWN_REQUEST,
  BUSINESS_KECAMATAN_REQUEST,
  BANK_LIST_REQUEST,
  BUSINESS_CITY_REQUEST,
  BUSINESS_NUMBER_OF_OUTLETS_REQUEST,
  BUSINESS_NUMBER_OF_OUTLETS_DATA,
  BUSINESS_CITIES_ALL_REQUEST,
  BUSINESS_CITIES_ALL_DATA,
  BUSINESS_CITIES_POPULAR_REQUEST,
  BUSINESS_CITIES_POPULAR_DATA,
  BUSINESS_SALES_REQUEST,
  CHANGE_BUSINESS_CATEGORIES_DATA,
  CHANGE_BUSINESS_CATEGORIES_ALL_DATA,
  CHANGE_BUSINESS_STARTS_DATA,
  CHANGE_BUSINESS_LOCATIONS_DATA,
  CHANGE_BUSINESS_PROVINCE_DATA,
  CHANGE_BUSINESS_CITY_DATA,
  CHANGE_BUSINESS_ZIPCODE_DATA,
  CHANGE_BUSINESS_KECAMATAN_DATA,
  CHANGE_BANK_LIST_DATA,
  CHANGE_BUSINESS_SALES_DATA,
  REDIRECT_TO,
  LOAD_RESET_PASSWORD,
  CHANGE_FORM_RESET_PASSWORD,
  SEND_RESET_PASSWORD,
  LOAD_PREPARE_ENCRYPTION,
  SET_PREPARE_ENCRYPTION,
  GET_PROFILE_REQUEST,
  SET_PROFILE,
  CLEAR_REGISTER_FORM,
  SHOW_LOADING_SPINNER,
  SET_IS_REGISTERED,
  SET_RESEND_VERIFICATION_EMAIL_STATE,
  TO_LOGIN_PAGE,
  SET_PERMISSIONS,
  DASHBOARD_SHOW_MODAL_OUTLET_MOBILE,
  SET_EXTERNAL_REDIRECT_URL,
  SHOW_ACTIVE_APPLICATIONS,
  BUSINESS_OPENINGS_REQUEST,
  CHANGE_BUSINESS_OPENINGS,
  SET_BUSINESS_INFO_DATA,
  BUSINESS_INFO_DATA_REQUEST,
} from './constants';

/**
 * Show the progress bar
 * @returns {{type, payload: {}}}
 */
export function showProgressBar() {
  return { type: SHOW_PROGRESS_BAR };
}
export function showLoadingSpinner(showLoadingSpinnerPayload) {
  return {
    type: SHOW_LOADING_SPINNER,
    payload: { showLoadingSpinner: showLoadingSpinnerPayload },
  };
}

export function hideProgressBar() {
  return { type: HIDE_PROGRESS_BAR };
}

/**
 * Sets the form state
 * @param  {object} newFormState          The new state of the form
 * @param  {string} newFormState.email   The new text of the email input field of the form
 * @param  {string} newFormState.password The new text of the password input field of the form
 */
export function changeForm(newFormState) {
  return { type: CHANGE_FORM, payload: { newFormState } };
}
export function showModalOutletMobile(value) {
  return {
    type: DASHBOARD_SHOW_MODAL_OUTLET_MOBILE,
    payload: { showModalOutletMobile: value },
  };
}
/**
 * Sets the form state
 * @param  {object} newFormRegState          The new state of the form
 * @param  {string} newFormRegState.email The new text of the email input field of the form
 * @param  {string} newFormRegState.password The new text of the password input field of the form
 * @param  {string} newFormRegState.confpassword The new text of the confirm password input field of the form
 */
export function changeFormRegister(newFormRegState) {
  return { type: CHANGE_FORM_REGISTER, payload: { newFormRegState } };
}

/**
 * Sets the form forgot state
 * @param  {object} newBusinessState          The new state of the form
 * @param  {string} newBusinessState.types The new text of the email input field of the form
 */
export function changeFormBusiness(newBusinessState) {
  return { type: CHANGE_FORM_BUSINESS, payload: { newBusinessState } };
}

/**
 * Sets the authentication state of the application
 * @param  {boolean} newAuthState True means a user is logged in, false means no user is logged in
 * @param  {object} user object. null if auth fails.
 */
export function setAuthState(newAuthState, user?) {
  return { type: SET_AUTH, payload: { newAuthState, user } };
}

/**
 * Sets the authentication state of the application
 * @param  {boolean} newAuthState True means a user is logged in, false means no user is logged in
 * @param  {object} user object. null if auth fails.
 */
export function setPermissionsState(permissions) {
  return { type: SET_PERMISSIONS, payload: { permissions } };
}

/**
 * Sets the `currentlySending` state, which displays a loading indicator during requests
 * @param  {boolean} sending True means we're sending a request, false means we're not
 */
export function sendingRequest(sending) {
  return { type: SENDING_REQUEST, payload: { sending } };
}

/**
 * Tells the app we want to log in a user
 * @param  {object} data          The data we're sending for log in
 * @param next
 * @param  {string} data.email The username of the user to log in
 * @param  {string} data.password The password of the user to log in
 */
export function loginRequest(data, next: string | null = null) {
  return { type: LOGIN_REQUEST, payload: { data, next } };
}

/**
 * Tells the app we want to log out a user
 */
export function logout() {
  return { type: LOGOUT };
}

export function resendVerificationEmail(data) {
  return { type: RESEND_VERIFICATION_EMAIL, payload: { data } };
}

/**
 * Sets the `error` state to the error received
 * @param  {object} error The error we got when trying to make the request
 */
export function requestError(error) {
  return { type: REQUEST_ERROR, payload: { error } };
}

export function businessTypes() {
  return { type: BUSINESS_TYPES_REQUEST };
}

export function changeBusinessTypesData(newBusinessTypes) {
  return { type: CHANGE_BUSINESS_TYPES_DATA, payload: { newBusinessTypes } };
}

export function businessCategories(data) {
  return { type: BUSINESS_CATEGORIES_REQUEST, payload: { data } };
}

export function changeBusinessCategoriesData(newBusinessCategories) {
  return {
    type: CHANGE_BUSINESS_CATEGORIES_DATA,
    payload: { newBusinessCategories },
  };
}

export function businessOpeningChoices() {
  return { type: BUSINESS_OPENINGS_REQUEST };
}

export function changeBusinessOpeningChoices(newBusinessOpeningChoices) {
  return {
    type: CHANGE_BUSINESS_OPENINGS,
    payload: { newBusinessOpeningChoices },
  };
}

export function businessNumberOfOutletsChoicesRequest() {
  return { type: BUSINESS_NUMBER_OF_OUTLETS_REQUEST };
}

export function businessNumberOfOutletsChoicesData(
  businessNumberOfOutletsChoices
) {
  return {
    type: BUSINESS_NUMBER_OF_OUTLETS_DATA,
    payload: { businessNumberOfOutletsChoices },
  };
}

export function newBusinessInfoRequest() {
  return {
    type: BUSINESS_INFO_DATA_REQUEST,
  };
}

export function setBusinessInformationData(newBusinessInformationData) {
  return {
    type: SET_BUSINESS_INFO_DATA,
    payload: { newBusinessInformationData },
  };
}

export function businessCategoriesAll() {
  return { type: BUSINESS_CATEGORIES_ALL_REQUEST };
}

export function changeBusinessCategoriesAllData(newBusinessCategoriesAll) {
  return {
    type: CHANGE_BUSINESS_CATEGORIES_ALL_DATA,
    payload: { newBusinessCategoriesAll },
  };
}

export function showActiveApplicationsAllData(showActiveApplications) {
  return {
    type: SHOW_ACTIVE_APPLICATIONS,
    payload: { showActiveApplications },
  };
}

export function businessStarts() {
  return { type: BUSINESS_STARTS_REQUEST };
}

export function changeBusinessStartsData(newBusinessStarts) {
  return { type: CHANGE_BUSINESS_STARTS_DATA, payload: { newBusinessStarts } };
}

export function businessLocations() {
  return { type: BUSINESS_LOCATIONS_REQUEST };
}

export function businessProvince() {
  return { type: BUSINESS_PROVINCE_REQUEST };
}

export function businessCity(provinceId) {
  return { type: BUSINESS_CITY_REQUEST, payload: { provinceId } };
}

export function businessZipcode(kecamatanId) {
  return { type: BUSINESS_ZIPCODE_REQUEST, payload: { kecamatanId } };
}

export function getDropdownData(data) {
  return { type: GET_DROPDOWN_REQUEST, payload: data };
}

export function businessKecamatan(cityId) {
  return { type: BUSINESS_KECAMATAN_REQUEST, payload: { cityId } };
}

export function bankList() {
  return { type: BANK_LIST_REQUEST };
}

export function changeBusinessLocationsData(newBusinessLocations) {
  return {
    type: CHANGE_BUSINESS_LOCATIONS_DATA,
    payload: { newBusinessLocations },
  };
}

export function changeBusinessProvinceData(newBusinessProvince) {
  return {
    type: CHANGE_BUSINESS_PROVINCE_DATA,
    payload: { newBusinessProvince },
  };
}

export function changeBusinessCityData(newBusinessCity) {
  return { type: CHANGE_BUSINESS_CITY_DATA, payload: { newBusinessCity } };
}

export function businessCitiesAllRequest() {
  return { type: BUSINESS_CITIES_ALL_REQUEST };
}

export function businessCitiesAllData(businessCitiesAll) {
  return {
    type: BUSINESS_CITIES_ALL_DATA,
    payload: { businessCitiesAll },
  };
}

export function businessCitiesPopularRequest() {
  return { type: BUSINESS_CITIES_POPULAR_REQUEST };
}

export function businessCitiesPopularData(businessCitiesPopular) {
  return {
    type: BUSINESS_CITIES_POPULAR_DATA,
    payload: { businessCitiesPopular },
  };
}

export function changeBusinessZipcodeData(newBusinessZipcode) {
  return {
    type: CHANGE_BUSINESS_ZIPCODE_DATA,
    payload: { newBusinessZipcode },
  };
}

export function changeBusinessKecamatanData(newBusinessKecamatan) {
  return {
    type: CHANGE_BUSINESS_KECAMATAN_DATA,
    payload: { newBusinessKecamatan },
  };
}

export function changeBankListData(newBankList) {
  return { type: CHANGE_BANK_LIST_DATA, payload: { newBankList } };
}

export function businessSales() {
  return { type: BUSINESS_SALES_REQUEST };
}

export function changeBusinessSalesData(newBusinessSales) {
  return { type: CHANGE_BUSINESS_SALES_DATA, payload: { newBusinessSales } };
}

/**
 * Sets the `error` state as empty
 */
export function clearError() {
  return { type: CLEAR_ERROR };
}

export function setAuthFromLocal() {
  return { type: SET_AUTH_FROM_LOCAL };
}

export function setAuthFromApi(data) {
  return { type: SET_AUTH_FROM_API, payload: { data } };
}

export function getFilteredDate(data) {
  return { type: GET_FILTERED_DATE, payload: { filteredDate: data } };
}

export function redirectTo(data) {
  return { type: REDIRECT_TO, payload: { url: data } };
}

export function loadResetPassword(data) {
  return { type: LOAD_RESET_PASSWORD, payload: { token: data } };
}

export function changeFormResetPassword(data) {
  return {
    type: CHANGE_FORM_RESET_PASSWORD,
    payload: { resetPasswordState: data },
  };
}

export function resetPassword(data, token) {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  return { type: SEND_RESET_PASSWORD, payload: { data, access_token: token } };
}

export function loadPrepareEncryption() {
  return { type: LOAD_PREPARE_ENCRYPTION };
}

export function setPrepareEncryption(data) {
  return {
    type: SET_PREPARE_ENCRYPTION,
    payload: {
      encryption: {
        // eslint-disable-next-line @typescript-eslint/naming-convention
        public_modulus: data.responseData.public_modulus,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        public_exponent: data.responseData.public_exponent,
        key: data.responseData.public_exponent,
      },
    },
  };
}

export function getProfileRequest(query) {
  return { type: GET_PROFILE_REQUEST, payload: { query } };
}

export function setProfile(profile) {
  return { type: SET_PROFILE, payload: { profile } };
}

export function clearRegisterForm() {
  return { type: CLEAR_REGISTER_FORM };
}

export function setIsRegistered(isRegistered) {
  return { type: SET_IS_REGISTERED, payload: { isRegistered } };
}

export function setResendEmailVerificationState(data) {
  return {
    type: SET_RESEND_VERIFICATION_EMAIL_STATE,
    payload: {
      resendVerificationEmail: {
        isModalShow: data.isModalShow,
        headerMessage: data.headerMessage,
        bodyMessage: data.bodyMessage,
        modalStatus: data.modalStatus,
      },
    },
  };
}

export function toLoginPage() {
  return { type: TO_LOGIN_PAGE };
}

export function setExternalRedirectURL(url) {
  return { type: SET_EXTERNAL_REDIRECT_URL, payload: { url } };
}
